import { render, staticRenderFns } from "./InfoRotina.vue?vue&type=template&id=6458a3ed"
import script from "./InfoRotina.vue?vue&type=script&lang=js"
export * from "./InfoRotina.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports